import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-03f3a492"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-signin" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "h3 mb-3 fw-normal" }, "Add City ", -1))
const _hoisted_3 = { class: "form-floating" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "floatingInput" }, "City Name", -1))
const _hoisted_5 = { class: "form-floating" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "floatingInput" }, "City Name Urdu", -1))
const _hoisted_7 = { class: "form-floating" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "floatingInput" }, "City Push Topic", -1))
const _hoisted_9 = { class: "form-floating" }
const _hoisted_10 = ["value"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "floatingInput" }, "Country", -1))
const _hoisted_12 = { class: "form-check" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "flexCheckDefault"
}, " Is Show ", -1))
const _hoisted_14 = { class: "form-check" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "flexCheckDefault"
}, " is second order cron ", -1))
const _hoisted_16 = { class: "form-check" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "flexCheckDefault"
}, " is third order cron ", -1))
const _hoisted_18 = { class: "form-floating" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "floatingInput" }, "Rider Booking Price start Fixed", -1))
const _hoisted_20 = { class: "form-floating" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "floatingInput" }, "Rider Booking Price start Flexible", -1))
const _hoisted_22 = { class: "form-floating" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "floatingInput" }, "Rider Booking Note Flexible", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "w-100 btn btn-lg btn-primary",
  type: "submit"
}, "Submit", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("form", {
      onSubmit: _cache[10] || (_cache[10] = _withModifiers(
//@ts-ignore
(...args) => ($setup.submit && $setup.submit(...args)), ["prevent"]))
    }, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.data.name) = $event)),
          class: "form-control",
          placeholder: "Package Title",
          required: ""
        }, null, 512), [
          [_vModelText, $setup.data.name]
        ]),
        _hoisted_4
      ]),
      _createElementVNode("div", _hoisted_5, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.data.name_urdu) = $event)),
          class: "form-control",
          placeholder: "City Name Uru",
          required: ""
        }, null, 512), [
          [_vModelText, $setup.data.name_urdu]
        ]),
        _hoisted_6
      ]),
      _createElementVNode("div", _hoisted_7, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.data.city_topic) = $event)),
          class: "form-control",
          placeholder: "City Push Topic",
          required: ""
        }, null, 512), [
          [_vModelText, $setup.data.city_topic]
        ]),
        _hoisted_8
      ]),
      _createElementVNode("div", _hoisted_9, [
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.data.country_id) = $event)),
          class: "form-control",
          required: ""
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.countries, (country) => {
            return (_openBlock(), _createElementBlock("option", {
              key: country.id,
              value: country.id
            }, _toDisplayString(country.name), 9, _hoisted_10))
          }), 128))
        ], 512), [
          [_vModelSelect, $setup.data.country_id]
        ]),
        _hoisted_11
      ]),
      _createElementVNode("div", _hoisted_12, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.data.is_show) = $event)),
          class: "form-check-input",
          type: "checkbox",
          id: "flexCheckDefault"
        }, null, 512), [
          [_vModelCheckbox, $setup.data.is_show]
        ]),
        _hoisted_13
      ]),
      _createElementVNode("div", _hoisted_14, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.data.is_second_order_cron) = $event)),
          class: "form-check-input",
          type: "checkbox",
          id: "flexCheckDefault"
        }, null, 512), [
          [_vModelCheckbox, $setup.data.is_second_order_cron]
        ]),
        _hoisted_15
      ]),
      _createElementVNode("div", _hoisted_16, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.data.is_third_order_cron) = $event)),
          class: "form-check-input",
          type: "checkbox",
          id: "flexCheckDefault"
        }, null, 512), [
          [_vModelCheckbox, $setup.data.is_third_order_cron]
        ]),
        _hoisted_17
      ]),
      _createElementVNode("div", _hoisted_18, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.data.booking_price_fixed) = $event)),
          type: "number",
          step: "0.1",
          class: "form-control",
          placeholder: "second package price",
          required: ""
        }, null, 512), [
          [_vModelText, $setup.data.booking_price_fixed]
        ]),
        _hoisted_19
      ]),
      _createElementVNode("div", _hoisted_20, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.data.booking_price_flexible) = $event)),
          type: "number",
          step: "0.1",
          class: "form-control",
          placeholder: "second package price",
          required: ""
        }, null, 512), [
          [_vModelText, $setup.data.booking_price_flexible]
        ]),
        _hoisted_21
      ]),
      _createElementVNode("div", _hoisted_22, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.data.booking_flexible_note) = $event)),
          type: "text",
          class: "form-control",
          placeholder: "second package price",
          required: ""
        }, null, 512), [
          [_vModelText, $setup.data.booking_flexible_note]
        ]),
        _hoisted_23
      ]),
      _hoisted_24
    ], 32)
  ]))
}